import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import FlagshipPromise from "../components/FlagshipPromise";
import Manifesto from "../components/Manifesto";
import Doctrine from "../components/Doctrine";
import Simulator from "../components/Simulator";
import Policies from "../components/Policies";
import SectorPorSector from "../components/SectorPorSector";
import BookSection from "../components/BookSection";
import MediaGallery from "../components/MediaGallery";
import JoinForm from "../components/JoinForm";
import OrganizerForm from "../components/OrganizerForm";
import DonateSection from "../components/DonateSection";
import PressSection from "../components/PressSection";
import EnLosMedios from "../components/EnLosMedios";
import Footer from "../components/Footer";
import SongButton from "../components/SongButton";
import InstallAppButton from "../components/InstallAppButton";
import WhatsAppButton from "../components/WhatsAppButton";
import useVisitTracker from "../hooks/useVisitTracker";

export const Home = () => {
  useVisitTracker();
  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <FlagshipPromise />
        <Manifesto />
        <Doctrine />
        <Simulator />
        <Policies />
        <SectorPorSector />
        <BookSection />
        <MediaGallery />
        <PressSection />
        <EnLosMedios />
        <JoinForm />
        <OrganizerForm />
        <DonateSection />
      </main>
      <Footer />
      <SongButton />
      <InstallAppButton />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
